export * from './utils';

export const isDateAfter = (d1: Date, d2: Date): boolean => d1.getTime() > d2.getTime();

export const isDateBefore = (d1: Date, d2: Date): boolean => d1.getTime() < d2.getTime();

export const isDateSameOrAfter = (d1: Date, d2: Date): boolean => d1.getTime() >= d2.getTime();

export const isDateSameOrBefore = (d1: Date, d2: Date): boolean => d1.getTime() <= d2.getTime();

export const isSameDay = (d1: Date, d2: Date): boolean => d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate();

/**
 * Check if the provided date between from and to
 * @param date
 * @param from
 * @param to
 */
export const isDateBetween = (date: Date, from: Date, to: Date): boolean => isDateSameOrAfter(date, from) && isDateSameOrBefore(date, to);

export const getDiffInDays = (d1: Date, d2: Date): number => Math.round((d1.getTime() - d2.getTime()) / (1000 * 60 * 60 * 24));

export const getDiffInMinutes = (d1: Date, d2: Date): number => Math.round((d1.getTime() - d2.getTime()) / (1000 * 60));

/**
 * Add time to a provided date object
 * @param date The original date object
 * @param unit The desired unit
 * @param amount The desired amount
 */
export const addToDate = (date: Date, unit: 'seconds' | 'minutes' | 'years', amount: number): Date => {
  const newDate = new Date(date);

  switch (unit) {
    case 'seconds':
      newDate.setSeconds(newDate.getSeconds() + amount);
      break;
    case 'minutes':
      newDate.setMinutes(newDate.getMinutes() + amount);
      break;
    case 'years':
      newDate.setFullYear(newDate.getFullYear() + amount);
      break;
    default:
      // do-nothing
  }

  return newDate;
};

export const fromNow = (date: Date): string => {
  const seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);
  const years = Math.floor(seconds / 31536000);
  const months = Math.floor(seconds / 2592000);
  const days = Math.floor(seconds / 86400);

  if (days > 548) {
    return `${years} years ago`;
  }
  if (days >= 320 && days <= 547) {
    return 'a year ago';
  }
  if (days >= 45 && days <= 319) {
    return `${months} months ago`;
  }
  if (days >= 26 && days <= 45) {
    return 'a month ago';
  }

  const hours = Math.floor(seconds / 3600);

  if (hours >= 36 && days <= 25) {
    return `${days} days ago`;
  }
  if (hours >= 22 && hours <= 35) {
    return 'a day ago';
  }

  const minutes = Math.floor(seconds / 60);

  if (minutes >= 90 && hours <= 21) {
    return `${hours} hours ago`;
  }
  if (minutes >= 45 && minutes <= 89) {
    return 'an hour ago';
  }
  if (seconds >= 90 && minutes <= 44) {
    return `${minutes} minutes ago`;
  }
  if (seconds >= 45 && seconds <= 89) {
    return 'a minute ago';
  }
  if (seconds >= 0 && seconds <= 45) {
    return 'a few seconds ago';
  }
  return '';
};

export const padWithZero = (value?: number): string => {
  if (value) {
    return value < 10 ? `0${value}` : value.toString();
  }
  return '00';
};

export const latestOfNowAndDate = (date: Date | null | undefined): number => {
  const currentDate = new Date();
  if (date && isDateAfter(date, currentDate)) {
    return date.getTime();
  }
  return currentDate.getTime();
};
